import { Toast } from './toast.service';

/**
 * Just a simple wrapper (at the moment) around the Toast class. The idea being that you can pass
 * this service into another class and mock out the Toast Service if need be
 */
export class ToastService {
    constructor() {}

    public newToast(
        type: string,
        promptText: string | undefined = undefined,
        promptTitle: string | undefined = undefined,
        duration = Toast.SHORT,
        onClick = undefined,
    ) {
        new Toast(type, promptText, promptTitle, duration, onClick);
    }
}
